<div class="modal-header">
  <h4 class="modal-title">{{ 'Liste complète des taux' | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="common-taux-input">
    <input type="text" [(ngModel)]="commonTaux" class="taux-input" maxlength="3" />
    <button type="button" class="btn btn-primary"
            [attr.title]="'Assigner un taux à toutes les semaines' | translate"
            (click)="setCommonTaux()">
      {{ 'Valider' | translate }}
    </button>
  </div>


  <div *ngIf="taux && taux.length" class="taux-wrapper">
    <div *ngFor="let tauxItem of taux; let i = index" class="taux-input-group">
      {{ i + 1 }} -
      <input type="text" class="taux-input" [value]="tauxItem.taux"
             (change)="updateTaux($event, tauxItem.id_week)"
             [attr.title]="tauxItem.date_wednesday | date:'dd/MM/yyyy'" maxlength="3" />
      <label>{{ 'editReservationModal.form.percent' | translate }}</label>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary validate-btn" (click)="saveAllTaux()">
    {{ 'editReservationModal.modalFooter.saveButton' | translate }}
  </button>
</div>
